import { CheckOutlined, CloseOutlined, DeleteOutlined, EditOutlined, PlusOutlined } from "@ant-design/icons";
import { Badge, Button, Card, Dropdown, Input, Menu, Modal, PageHeader, Select, Space, Table, Tag, Tooltip, Typography } from "antd";
import { useEffect, useState } from "react";
import { Link, useHistory } from "react-router-dom/cjs/react-router-dom.min";
import { deleteTrainingBundle, getTrainingBundles, patchTrainingBundle } from "../../appRedux/actions/TrainingBundles";
import { useLocation } from 'react-router-dom';
import { useMemo } from 'react';
import { toRupiah } from "../../libs";
import { useDispatch, useSelector } from "react-redux";
import { getTrainingOptions } from "../../appRedux/actions";
import moment from "moment";

export default function TrainingBundlePage() {
  const columns = () => {
    let backgroundColor = "#faf70d";
    let result = [
      {
        title: "Nama",
        dataIndex: "name",
        key: "name",
        render: (name, field) => {
          return {
            props: {
              style: { background: !field.enabled ? backgroundColor : "" }
            },
            children: (
              <Badge
                status={field.enabled ? "success" : "error"}
                text={name}
              />
            )
          }
        },
      },
      {
        title: "Harga",
        dataIndex: "price",
        key: "price",
        render: (text, field) => {
          return {
            props: {
              style: { background: !field.enabled ? backgroundColor : "" }
            },
            children: (
              <>
                {(field.is_online) &&
                  <>
                    <Tooltip title="Online">
                      <Tag color="green" style={{ margin: 1 }}>{toRupiah(text)}</Tag>
                    </Tooltip>
                  </>
                }
                {(!field.is_online) &&
                  <>
                    <Tooltip title="Offline">
                      <Tag color="blue" style={{ margin: 1 }}>{toRupiah(text)}</Tag>
                    </Tooltip>
                  </>
                }
              </>
            )
          }
        },
      },
      {
        title: "Status",
        dataIndex: "enabled",
        key: "enabled",
        render: (enabled, field) => {
          return {
            props: {
              style: { background: !field.enabled ? backgroundColor : "" }
            },
            children: (
              <>
                {enabled &&
                  <Tag color="green" style={{ margin: 1 }}>AKTIF</Tag>
                }
                {!enabled &&
                  <Tag color="blue" style={{ margin: 1 }}>TIDAK</Tag>
                }
              </>
            )
          }
        },
      },
      {
        title: "Training",
        dataIndex: "training_bundles_trainings",
        key: "training_bundles_trainings",
        responsive: ["md"],
        render: (training_bundles_trainings, field) => {
          return {
            props: {
              style: { background: !field.enabled ? backgroundColor : "" }
            },
            children: <Space direction="vertical">
              {training_bundles_trainings.length > 0 && training_bundles_trainings.map(training => {
                return <Space key={training.id}>
                  <Tag>{training.training_option_id ? trainingOptions.find(t => t.id === training.training_option_id).name : "-"}</Tag>
                  {training.is_online === true &&
                    <Tag color="green">ONLINE</Tag>
                  }
                  {training.is_online === false &&
                    <Tag color="blue">OFFLINE</Tag>
                  }
                  {training.is_online === null &&
                    <Tag color="red">ONLINE & OFFLINE</Tag>
                  }
                  <Tag>{training.location ? training.location : "Semua Lokasi"}</Tag>
                  {(field.trainings.length > 0 && training.training_id) ?
                    <Tag>{field.trainings.find(t => t.id === training.training_id).dates_summary}</Tag>
                    :
                    <Tag>{(training.year && training.month) ? moment(training.year + "-" + training.month, "YYYY-MM").format("MMMM YYYY") : "Semua Bulan"}</Tag>
                  }
                </Space>
              })}
            </Space>
          }
        },
      },
    ];
    result.push({
      key: "action",
      align: "right",
      render: (field) => {
        return {
          props: {
            style: { background: !field.enabled ? backgroundColor : "" }
          },
          children: <Dropdown
            overlay={
              <Menu>
                <Menu.Item key="edit" icon={<EditOutlined />}>
                  <Link to={"/training-bundle/" + field.id + "/edit"}>
                    Edit
                  </Link>
                </Menu.Item>
                {field.enabled ? (
                  <Menu.Item
                    danger
                    key="cancel"
                    icon={<CloseOutlined />}
                    onClick={() => activateBundle(field.id, false)}
                  >
                    Nonaktifkan
                  </Menu.Item>
                ) : (
                  <Menu.Item
                    key="enable"
                    icon={<CheckOutlined />}
                    onClick={() => activateBundle(field.id, true)}
                  >
                    Aktifkan
                  </Menu.Item>
                )}
                <Menu.Item
                  key="0"
                  icon={<DeleteOutlined />}
                  danger
                  onClick={() => deleteBundle(field.id)}
                >
                  Hapus
                </Menu.Item>
              </Menu>
            }
            placement="bottomRight"
            trigger={["click"]}
          >
            <i className="gx-icon-btn icon icon-ellipse-v" />
          </Dropdown>
        }
      },
    });
    return result;
  };

  const { search } = useLocation();
  const history = useHistory();
  const dispatch = useDispatch();

  const [loading, setLoading] = useState(true);
  const [bundles, setBundles] = useState(null);
  const [meta, setMeta] = useState({});

  const { trainingOptions, getTrainingOptionsLoading } = useSelector(
    ({ trainingOption }) => trainingOption
  );

  function activateBundle(id, enabled) {
    patchTrainingBundle(id, { enabled: enabled }).then(() => {
      fetchData();
    });
  }

  function deleteBundle(id) {
    Modal.confirm({
      title: "Konfirmasi",
      content: "Apakah anda yakin ingin menghapus training bundle ini ?",
      onOk: (close) => {
        close();
        deleteTrainingBundle(id).then(() => {
          fetchData();
        })
      },
    });
  }

  function onSearch(filter) {
    const params = new URLSearchParams(search);
    Object.keys(filter).forEach((key) => {
      if (filter[key] !== null && filter[key] !== undefined && filter[key] !== "") {
        params.set(key, filter[key]);
      } else {
        params.delete(key);
      }
    });
    history.push({
      search: params.toString(),
    });
  }

  async function fetchData() {
    setLoading(true);
    const params = new URLSearchParams(search);
    const filter = {
      current_page: params.get('current_page') || '1',
      page_size: params.get('page_size') || '10',
      search: params.get('search') || '',
      enabled: params.get('enabled') || '',
      training_option: params.get('training_option') || '',
    };
    getTrainingBundles(filter).then(response => {
      if (response.data.length === 0 && filter.current_page > 1) {
        params.set('current_page', 1);
        params.set('page_size', 10);
        history.push({
          search: params.toString(),
        });
        return;
      }
      setBundles(response.data);
      setMeta(response.meta);
      setLoading(false);
    })
  }

  useEffect(() => {
    fetchData();
  }, [search]);

  useEffect(() => {
    dispatch(getTrainingOptions({ page_size: 1000 }));
  }, [dispatch]);

  return (
    <>
      <PageHeader
        ghost={false}
        title="Training Bundle"
        extra={
          <>
            <Link to="/training-bundle/add">
              <Button
                style={{ margin: 0 }}
                type="primary"
                icon={<PlusOutlined />}
              >
                Tambah
              </Button>
            </Link>
          </>
        }
      />
      <Card bordered={false} style={{ borderRadius: 0 }}>
        <Space direction="vertical" style={{ width: "100%" }}>
          <Space wrap>
            <Input.Search
              style={{ margin: 0 }}
              allowClear
              placeholder="Cari"
              onSearch={(v) => onSearch({ search: v })}
              onChange={(e) => onSearch({ search: e.target.value })}
              value={new URLSearchParams(search).get('search') || ''}
            />
            <Select
              value={new URLSearchParams(search).get('enabled') === 'true' ? true : new URLSearchParams(search).get('enabled') === 'false' ? false : null}
              showSearch
              optionFilterProp="label"
              onChange={(v) => onSearch({ enabled: v })}
              style={{ width: "9rem" }}
            >
              <Select.Option value={null} label="semua">
                Semua Status
              </Select.Option>
              <Select.Option value={true} label="online">
                Aktif
              </Select.Option>
              <Select.Option value={false} label="offline">
                Tidak Aktif
              </Select.Option>
            </Select>
            <Select
              showSearch
              placeholder="pilih pilihan training"
              optionFilterProp="children"
              filterOption={(input, option) =>
                option.children.toLowerCase().indexOf(input.toLowerCase()) >= 0
              }
              style={{ width: "16rem" }}
              value={new URLSearchParams(search).get('training_option') || null}
              onChange={(v) => onSearch({ training_option: v })}
            >
              {trainingOptions.map((t) => (
                <Select.Option key={t.id} value={t.name} label={t.name}>
                  {t.name}
                </Select.Option>
              ))}
            </Select>
            <Button
              type="primary"
              style={{ margin: 0 }}
              onClick={() => {
                history.push('/training-bundle');
              }}
            >
              Reset
            </Button>
          </Space>
          <Table
            loading={loading}
            size="small"
            columns={columns()}
            dataSource={bundles && bundles.map((bundle) => ({
              ...bundle,
              key: bundle.id,
            }))}
            pagination={{
              total: meta.total,
              position: ["bottomCenter"],
              responsive: true,
              onChange: (page, pageSize) => {
                const params = new URLSearchParams(search);
                params.set('current_page', page);
                params.set('page_size', pageSize);
                history.push({
                  search: params.toString(),
                });
              },
              pageSize: meta.page_size,
              current: meta.current_page,
            }}
          />
        </Space>
      </Card>
    </>
  );
}